export function frequencyCounts(data: string[]): Map<string, number>;
export function frequencyCounts(data: number[]): Map<number, number>;

export function frequencyCounts(data: any) {
  // Find unique counts of each datapoint
  let frequency: Map<typeof data[0], number> = new Map();
  for (let i = 0; i < data.length; i++) {
    let key = data[i];
    if (key in frequency) {
      frequency[key] += 1;
    } else {
      frequency[key] = 1;
    }
  }

  // sort
  let keys = Object.keys(frequency).sort();
  let tmp: Map<typeof data[0], number> = new Map();
  for (let key of keys) {
    tmp[key] = frequency[key];
  }

  return tmp;
}
